module.exports = __webpack_public_path__ + "img/profitAndLoss-xl.d233c1be.svg";